import { Box, Flex } from "@mantine/core";
import clsx from "clsx";
import { ReactNode } from "react";

interface IconItemProps {
  childrenAfter?: ReactNode;
  icon: React.ReactElement;
  isShow?: boolean;
  contentAs?: "p" | "div";
  align?: "top" | "center" | "bottom";
  children: ReactNode;
  className?: string;
  withoutSpan?: boolean;
  onClick?: () => void;
}

const IconItem: React.FC<IconItemProps> = ({
  childrenAfter,
  align = "top",
  children,
  isShow = true,
  icon,
  contentAs = "p",
  withoutSpan = false,
  className,
  onClick = () => {},
}) => {
  if (!children || !isShow) {
    return <></>;
  }

  return (
    <Flex gap={4} align={align} onClick={onClick}>
      {withoutSpan ? (
        icon
      ) : (
        <span className={clsx("h-7 min-w-[24px]", className)}>{icon}</span>
      )}
      <Flex
        wrap={"wrap"}
        direction={"column"}
        className={clsx("min-w-0 leading-none", { "mt-1": align === "top" })}
      >
        <Box component={contentAs}>{children}</Box>
        <>{childrenAfter}</>
      </Flex>
    </Flex>
  );
};

export default IconItem;
